import { EHTMLDisplay, ESize, ETextColor } from 'src/styles/theme/utils/enums';
import {
	addFramesStyles,
	addHiddenRangesStyles,
	addMarginStyles,
	addPaddingStyles,
	addTransition,
	getTextColor,
	getThemeColor
} from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { INGIcon } from './NGIcon.type';

const gradient = css`
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
`;

export const StyledIcon = styled.span<{ size: INGIcon['size']; framesAuto?: boolean; display?: EHTMLDisplay }>`
	${(p) => css`
		display: flex;
		justify-content: center;
		align-items: center;

		${p.display ? `display: ${p.display};` : ''}

		${p.textColor === ETextColor.gradientGold
			? `
					${gradient}
					background-image: linear-gradient(155.3deg, #9f8c6c 29.33%, #ffeecf 50.34%, #9f8c6c 70.95%);
			  `
			: p.textColor === ETextColor.gradientGeneral
			? `
					${gradient}
					background-image: radial-gradient(82.76% 82.76% at 52.71% 6.05%, #76552F 14.65%, #9F8C6C 100%);
				`
			: `color: ${getTextColor(p)};`}

		${p.shadowColor ? `text-shadow: 0px 0px 12px ${getThemeColor(p.theme, p.shadowColor)};` : ''}
		${p.disabled ? 'opacity: 0.3;' : ''}

		${addTransition()}

		${addPaddingStyles(p)}
		${addMarginStyles(p)}
		${addHiddenRangesStyles(p)}

		text-align: center;
		line-height: 1;

		${() => {
			if (!p.gradientColor) {
				return '';
			}

			return css`
				border: 1px solid ${getTextColor(p)};
				border-radius: 50%;

				padding: 10px;
				background-image: linear-gradient(-45deg, ${getThemeColor(p.theme, p.gradientColor)} 0%, #00000000 100%);
			`;
		}}

		${() => {
			if (!p.size) {
				return '';
			}

			switch (p.size) {
				case ESize['2xs']:
					return `
          font-size: 8px;
					width: 15px;
					height: 15px;
        `;
				case ESize.xs:
					return `
          font-size: 12px;
					width: 25px;
					height: 25px;
        `;
				case ESize.s:
					return `
          font-size: 16px;
					width: 35px;
					height: 35px;
        `;
				case ESize.m:
					return `
          font-size: 20px;
					width: 40px;
					height: 40px;
        `;
				case ESize.l:
					return `
          font-size: 36px;
					width: 60px;
					height: 60px;
        `;
				case ESize.xl:
					return `
          font-size: 46px;
					width: 90px;
					height: 90px;
        `;
				default:
					return ``;
			}
		}}

		${addFramesStyles(p)}

		${p.framesAuto ? `width: auto; height: auto;` : ''}
	`}
`;
